(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-annandale-trade"] && !Shopify.designMode) return;
  try {
    
  function initialiseAnnandaleTrade() {
    document.querySelectorAll('[data-ml-trade]').forEach(section => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';
      const analyticsKey = 'ml-annandale-trade:' + section.dataset.audience + ':' + window.location.pathname;
      const form = section.querySelector('form');
      if (form) {
        form.addEventListener('submit', () => {
          const privacy = window.Shopify && window.Shopify.customerPrivacy;
          if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
          try { window.sessionStorage.removeItem(analyticsKey); } catch (error) { }
        });
      }
      const success = section.querySelector('[data-ml-trade-success]');
      const errors = section.querySelector('[data-ml-trade-errors]');
      if (errors) errors.focus({ preventScroll: false });
      if (!success || section.dataset.designMode === 'true') return;
      success.focus({ preventScroll: false });
      const detail = { lead_type: 'annandale_' + section.dataset.audience, form_kind: 'annandale_trade' };
      section.dispatchEvent(new CustomEvent('ml:annandale-trade-success', { bubbles: true, detail }));
      let measured = false;
      const measureSuccess = () => {
        if (measured || typeof window.gtag !== 'function') return;
        const privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
        measured = true;
        try {
          if (window.sessionStorage.getItem(analyticsKey) === 'measured') return;
          window.sessionStorage.setItem(analyticsKey, 'measured');
        } catch (error) { }
        window.gtag('event', 'generate_lead', detail);
      };
      measureSuccess();
      document.addEventListener('visitorConsentCollected', measureSuccess);
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          if (!error) measureSuccess();
        });
      }
    });
  }
  initialiseAnnandaleTrade();
  document.addEventListener('DOMContentLoaded', initialiseAnnandaleTrade);
  document.addEventListener('shopify:section:load', initialiseAnnandaleTrade);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-request"] && !Shopify.designMode) return;
  try {
    
  function selectMeadowLanePackage() {
    const params = new URLSearchParams(window.location.search);
    const value = params.get('pakket');
    if (params.get('onderwerp') === 'vatgesprek') {
      document.querySelectorAll('[data-ml-subject]').forEach(select => { if (!select.dataset.mlReady) { select.selectedIndex = 2; select.dataset.mlReady = 'true'; } });
    }
    document.querySelectorAll('[data-ml-package]').forEach(select => {
      if (select.dataset.mlReady) return;
      select.dataset.mlReady = 'true';
      select.value = ['brons', 'zilver', 'goud', 'maatwerk'].includes(value) ? value : 'maatwerk';
      const update = () => {
        select.closest('form').querySelectorAll('[data-ml-summary]').forEach(summary => {
          summary.hidden = summary.dataset.mlSummary !== select.value;
        });
      };
      select.addEventListener('change', update);
      update();
    });
  }
  selectMeadowLanePackage();
  document.addEventListener('DOMContentLoaded', selectMeadowLanePackage);
  document.addEventListener('shopify:section:load', selectMeadowLanePackage);

  } catch(e) { console.error(e); }
})();
})();
